import { plotColors } from '@revelio/replots';

import { usePrimaryFilterState } from '../../../filters/hooks/usePrimaryFilterState';
import { useTabContentConfig } from '../../PageConfigProvider/PageConfigProvider';

export const useActiveColors = () => {
  const { primaryFilter } = useTabContentConfig();
  const { primaryFilter: primaryFilterState } = usePrimaryFilterState(
    primaryFilter?.id
  );

  const { primarySelections } = primaryFilterState ?? {};

  const colorMap = primarySelections
    ?.filter((selection) => selection.isActive)
    .reduce(
      (acc, selection, index) => {
        const entityId = selection.id.split('_').slice(-1)[0];
        const key = `${entityId}_${selection.name}`;
        acc[key] = plotColors[index % plotColors.length] || '#5CA9E9';
        return acc;
      },
      {} as Record<string, string>
    );

  return { colorMap };
};

export const getActiveColor = ({
  colorMap,
  dimension,
  id,
}: {
  colorMap?: Record<string, string>;
  dimension: string;
  id?: string | null;
}): string | undefined => {
  if (!colorMap) return undefined;

  if (id !== null && id !== undefined && id !== '') {
    const exactKey = `${id}_${dimension}`;
    const exactColor = colorMap[exactKey];
    if (exactColor) return exactColor;

    const labels: string[] = Object.keys(colorMap).map(
      (key) => key.split('_').slice(-1)[0] ?? ''
    );
    const matchedLabels = labels.filter(
      (label) => label.includes(dimension) || dimension.includes(label)
    );
    if (matchedLabels.length !== 1) return undefined;
    const matchedLabelIndex = labels.indexOf(matchedLabels?.[0] ?? '');
    const colorMapValues = Object.values(colorMap);
    return colorMapValues[matchedLabelIndex];
  }

  return colorMap[dimension];
};
